import { useParams } from 'react-router-dom';

export const useProject = () => {
    const { workspaceId, projectId } = useParams<{ workspaceId: string, projectId: string }>()
    
    return {
        workspaceId: Number(workspaceId),
        projectId: Number(projectId)
    }
}